import React, { useEffect } from 'react';
import { useLDClient } from '@launchdarkly/react-sdk';

import type { UseChatAssistantUser } from '/packages/shared-components/ChatAssistant/FloatingChatAssistant';
import { buildLaunchDarklyContext, type LaunchDarklyUserInput } from './launchDarklyContext';
import { isLaunchDarklyConfigured, type LaunchDarklyApp } from './constants';

export interface LaunchDarklyUserIdentifyProps {
  app: LaunchDarklyApp;
  useUser: UseChatAssistantUser;
}

const toLaunchDarklyUserInput = (currentUser: object | null | undefined): LaunchDarklyUserInput | null => {
  if (!currentUser || typeof currentUser !== 'object') {
    return null;
  }

  const user = currentUser as LaunchDarklyUserInput & {
    selectedPartner?: { id?: string | null } | null;
  };

  return {
    id: user.id,
    email: user.email,
    userType: user.userType,
    defaultPartnerId: user.defaultPartnerId,
    selectedPartner: user.selectedPartner,
  };
};

export const LaunchDarklyUserIdentify = ({ app, useUser }: LaunchDarklyUserIdentifyProps) => {
  const ldClient = useLDClient();
  const { currentUser, loadingUser } = useUser();

  useEffect(() => {
    if (!isLaunchDarklyConfigured() || !ldClient || loadingUser) {
      return;
    }

    void ldClient.identify(buildLaunchDarklyContext(app, toLaunchDarklyUserInput(currentUser)));
  }, [app, currentUser, ldClient, loadingUser]);

  return null;
};
